import React from "react";
import "./NoData.css";

// Import React Icons
import * as FaIcons from "react-icons/fa";

// ✅ Explicitly type the icon component for TS safety
const FaCompass = FaIcons.FaCompass as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

interface NoDataProps {
  message?: string;
  icon?: React.ReactNode;   // ✅ changed type to accept an icon component
  subtitle?: string;
  actionText?: string;
  onAction?: () => void;
}

const NoData: React.FC<NoDataProps> = ({
  message = "No data found",
  icon = <FaCompass />,  // ✅ default icon replaced with FaCompass
  subtitle = "Try adjusting your filters or search query.",
  actionText,
  onAction
}) => {
  return (
    <div className="no-data-card">
      <div className="no-data-icon animated-icon">{icon}</div>
      <p className="no-data-title">{message}</p>

      {subtitle && <p className="no-data-subtext">{subtitle}</p>}

      {actionText && onAction && (
        <button
          className="no-data-action-btn"
          onClick={onAction}
        >
          {actionText}
        </button>
      )}
    </div>
  );
};

export default NoData;
